/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import { bindingTypes, LABEL } from '@adalo/constants'
import { connect } from 'react-redux'
import deepEqual from 'fast-deep-equal/es6'

import { getOptions } from 'utils/redux/reduxConnect'
import { timingsWrapper } from 'utils/timings'
import { evaluateBinding } from '../../utils/dependencies'
import ActionWrapper from '../ActionWrapper'
import BaseObject from '../BaseObject'
import LabelSub from './LabelSub'
import AppContext from '../../contexts/AppContext'
import { getBindingsFromProps } from '../../utils/bindingUtils'

const CRITICAL_PROPS_NON_FUNCTION = [
  'object',
  'component',
  'textBindingData',
  'bindingData',
]

class Label extends BaseObject {
  static contextType = AppContext

  constructor(props) {
    super(props)

    this.shouldComponentUpdate = timingsWrapper(this.shouldComponentUpdate.bind(this), `${LABEL}: shouldComponentUpdate`) // prettier-ignore
    this.render = timingsWrapper(this.render.bind(this), `${LABEL}: render`)
  }

  shouldComponentUpdate(nextProps) {
    for (const prop of CRITICAL_PROPS_NON_FUNCTION) {
      if (!deepEqual(this.props[prop], nextProps[prop])) {
        return true
      }
    }

    return false
  }

  render() {
    const { object, component, textBindingData, bindingData } = this.props
    const binding = object.dataBinding
    const { attributes } = object

    const { selectable } = attributes
    let text = textBindingData

    if (binding) {
      if (binding.bindingType === bindingTypes.SET_TEXT) {
        text = bindingData
      }

      if (!text && binding.includeDefault) {
        text = attributes.text
      }
    }

    const { maxLength } = attributes
    if (maxLength > 0 && text.length > maxLength) {
      text = `${text.substring(0, maxLength).trim()}...`
    }

    const wrapperStyles = {
      ...object.layout,
      opacity: attributes.opacity,
    }

    const textStyles = this.textStyles()

    const { fontSize } = textStyles

    textStyles.minHeight = Math.round(fontSize * 1.2)

    if (text && typeof text !== 'string') {
      text = String(text)
    }

    let numberOfLines

    if (attributes.multiline === false) {
      numberOfLines = 1
    }

    return (
      <ActionWrapper
        bindingData={bindingData}
        component={component}
        object={object}
        style={wrapperStyles}
        {...getBindingsFromProps(this.props)}
      >
        <LabelSub
          selectable={selectable}
          numberOfLines={numberOfLines}
          style={textStyles}
        >
          {text}
        </LabelSub>
      </ActionWrapper>
    )
  }
}

const mapStateToProps = (
  state,
  {
    object,
    getBinding,
    getParams,
    getBindingsList,
    getApp,
    getFileUploadsBaseURL,
    getImageUploadsBaseURL,
    listItemId,
  }
) => ({
  textBindingData: evaluateBinding(state, object.attributes.text, {
    getParams,
    getBinding,
    getBindingsList,
    getApp,
    getFileUploadsBaseURL,
    getImageUploadsBaseURL,
    listItemId,
  }),
})

const mapStateToPropsWithTimings = timingsWrapper(
  mapStateToProps,
  `${LABEL}: mapStateToProps`
)

const ConnectedLabel = connect(
  mapStateToPropsWithTimings,
  undefined,
  undefined,
  getOptions(LABEL)
)(Label)

export default class LabelWrapper extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)

    this.shouldComponentUpdate = timingsWrapper(this.shouldComponentUpdate.bind(this), `${LABEL}Wrapper: shouldComponentUpdate`) // prettier-ignore
  }

  shouldComponentUpdate(nextProps) {
    for (const prop of CRITICAL_PROPS_NON_FUNCTION) {
      // eslint-disable-next-line react/destructuring-assignment
      if (!deepEqual(this.props[prop], nextProps[prop])) {
        return true
      }
    }

    return false
  }

  render() {
    const { getApp } = this.context
    const app = getApp()

    return <ConnectedLabel {...this.context} {...this.props} app={app} />
  }
}
